import { FC, SVGAttributes } from "react";

const FlagEs: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <defs>
      <path id="rlfw3pwi1a" d="M0 2H16V14H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="xwfiix6ikb" fill="#fff">
        <use xlinkHref="#rlfw3pwi1a" />
      </mask>
      <use fill="#FFC400" xlinkHref="#rlfw3pwi1a" />
      <path
        fill="#C60B1E"
        d="M0 14L0 11 16 11 16 14zM0 5L0 2 16 2 16 5z"
        mask="url(#xwfiix6ikb)"
      />
      <g mask="url(#xwfiix6ikb)">
        <g>
          <g>
            <g>
              <path
                fill="#AD1519"
                fillRule="nonzero"
                d="M.085.261s-.01 0-.017-.003L.044.238.03.226.016.209S.001.183.008.164c.007-.02.02-.026.03-.032L.072.12.096.111.124.104.136.098C.142.096.15.096.156.095.16.093.171.089.178.089l.035.002.035.001L.296.09H.32C.33.09.347.097.352.099l.044.016c.011.003.037.008.05.014.012.005.02.015.025.023.006.008.007.017.01.023.002.005.002.017 0 .023L.47.215.457.237.44.251S.428.262.418.26C.408.261.31.243.248.243.185.243.085.26.085.26z"
                transform="translate(1 6) translate(1 1.173) translate(.192)"
              />
              <g transform="translate(1 6) translate(1 1.173) translate(.192) translate(.064)">
                <circle
                  cx=".205"
                  cy=".121"
                  r="1"
                  fill="#C8B100"
                  fillRule="nonzero"
                />
                <circle
                  cx=".222"
                  cy=".122"
                  r="1"
                  fill="#C8B100"
                  fillRule="nonzero"
                />
                <circle
                  cx=".215"
                  cy=".096"
                  r="1"
                  fill="#C8B100"
                  fillRule="nonzero"
                />
                <path
                  fill="#C8B100"
                  fillRule="nonzero"
                  d="M0.259 0.087L0.259 0.106 0.159 0.106 0.159 0.087 0.196 0.087 0.196 0.043 0.171 0.043 0.171 0.025 0.196 0.025 0.196 0.006 0.219 0.006 0.219 0.025 0.244 0.025 0.244 0.043 0.219 0.043 0.219 0.087 0.259 0.087"
                />
                <path d="M.229.047c.024.007.04.03.036.056C.262.128.241.147.215.147.192.147.17.128.167.103.163.078.178.053.202.047" />
                <path
                  fill="#C8B100"
                  fillRule="nonzero"
                  d="M.185.258H.083L.08.233.075.206.07.174C.042.136.016.112.007.117.01.11.012.105.017.102c.025-.015.077.02.116.08l.01.016h.085l.01-.016c.038-.06.09-.095.115-.08.006.003.008.008.01.015C.356.112.33.137.3.174L.295.206.291.233.288.258H.185z"
                />
                <path d="M.012.117c.02-.014.064.03.1.097M.36.117c-.02-.014-.064.03-.1.097" />
              </g>
              <g
                fill="#C8B100"
                fillRule="nonzero"
                transform="translate(1 6) translate(1 1.173) translate(.192) translate(0 .15)"
              >
                <path d="M.098.186C.093.166.085.146.085.146.127.126.185.112.25.112s.123.013.164.034L.402.18C.398.191.394.21.394.21.356.19.308.18.249.18.189.18.132.193.102.212L.097.186" />
                <path d="M.249.251c.052 0 .109-.014.13-.024C.393.22.401.21.4.196.4.19.396.184.392.18.361.163.305.151.25.151c-.056 0-.112.012-.143.03C.102.184.099.19.098.196.096.209.105.22.118.227c.022.01.08.024.131.024z" />
                <path d="M.416.149L.403.124S.391.14.376.135C.36.13.356.091.356.091S.339.12.326.119C.31.116.301.091.301.091S.287.114.274.11C.26.11.248.075.248.075S.235.11.221.114C.208.115.197.087.197.087S.191.116.175.122C.158.128.143.093.143.093S.133.127.122.135C.111.144.096.123.096.123L.09.143C.09.15.085.15.085.15l.004.022C.129.147.186.131.249.131c.064 0 .121.016.163.043L.416.149z" />
                <path d="M.25.053l.005.002v.012c0 .02.01.035.023.035.01 0 .02-.01.023-.024L.304.065V.08c.002.017.013.03.024.03.014 0 .024-.016.024-.036V.07L.359.058l.004.014-.002.015c0 .019.01.034.023.034C.392.12.399.115.403.106l.004-.01v.012c0 .011.003.022.01.024 0 0 .009 0 .02-.013C.448.106.454.094.454.094l.001.014s-.01.028-.02.036C.428.15.42.154.414.153.406.15.401.143.4.133.395.137.389.14.383.14.369.14.357.128.353.11.345.121.337.128.327.128.317.128.307.12.3.108.295.119.287.124.278.124.266.123.255.113.249.1.243.114.233.123.221.123.21.123.203.118.197.109.191.12.181.128.171.128.16.128.15.122.146.111.14.128.129.14.116.14.108.14.102.137.098.133.096.143.09.15.084.153.078.155.07.149.064.144.054.136.042.108.042.108L.044.094S.05.106.06.12c.011.014.02.013.02.013C.087.13.09.119.09.108V.096l.005.01C.1.115.106.12.114.12.127.12.137.106.137.087c0-.005 0-.01-.002-.015L.139.058l.007.011v.004c0 .02.01.035.024.035.012 0 .022-.012.023-.03L.194.066l.004.013C.2.092.21.102.22.102.233.102.244.086.244.067L.243.055.249.053z" />
                <path d="M.249.136C.185.136.127.161.085.2.083.202.08.196.078.188.078.18.08.17.082.167.124.126.183.1.25.1s.125.026.167.067C.419.169.421.179.42.188.419.196.416.202.413.2.37.16.313.137.249.136zM.091.157S.066.12.048.102C.034.09.002.078.002.078c0-.006.019-.021.04-.021.011 0 .023.005.03.015L.073.057S.09.06.097.08c.008.021.004.053.004.053S.097.15.09.157z" />
                <path d="M0.134 0.094L0.128 0.148 0.046 0.16 0.034 0.15 0.036 0.131 0.098 0.06 0.134 0.094" />
                <path d="M.045.097C.057.085.08.088.098.103c.018.015.024.038.012.05C.098.166.074.163.057.147.039.132.033.109.045.097z" />
                <path d="M.105.128C.1.11.105.09.118.086c.014-.003.03.009.037.027.006.019 0 .038-.014.042C.128.159.112.147.105.128z" />
                <path d="M0.1 0.109L0.128 0.15 0.195 0.093 0.2 0.075 0.19 0.061 0.113 0.05 0.1 0.109" />
                <path d="M0.158 0.016L0.115 0.05 0.171 0.111 0.185 0.116 0.196 0.107 0.215 0.033 0.158 0.016" />
                <path d="M0.239 0.083L0.225 0.138 0.149 0.127 0.139 0.113 0.145 0.094 0.211 0.038 0.239 0.083" />
                <circle cx=".178" cy=".097" r="1" />
                <path d="M.208.105C.205.085.216.068.23.066.243.064.257.079.26.099.263.118.252.136.238.137.225.139.211.124.208.105z" />
                <path d="M0.209 0.087L0.23 0.135 0.301 0.099 0.309 0.084 0.301 0.067 0.23 0.035 0.209 0.087" />
                <path d="M0.28 0.003L0.23 0.029 0.268 0.096 0.28 0.103 0.293 0.096 0.33 0.029 0.28 0.003" />
                <path d="M0.349 0.087L0.328 0.135 0.257 0.099 0.249 0.084 0.257 0.067 0.328 0.035 0.349 0.087" />
                <circle cx=".289" cy=".087" r="1" />
                <path d="M.37.105C.37.085.36.068.346.066.333.064.32.079.317.099.315.118.324.136.338.137.352.139.366.124.37.105z" />
                <path d="M0.32 0.083L0.334 0.138 0.41 0.127 0.42 0.113 0.414 0.094 0.348 0.038 0.32 0.083" />
                <path d="M0.406 0.016L0.449 0.05 0.394 0.111 0.38 0.116 0.369 0.107 0.349 0.033 0.406 0.016" />
                <path d="M0.459 0.109L0.432 0.15 0.365 0.093 0.359 0.075 0.37 0.061 0.446 0.05 0.459 0.109" />
                <circle cx=".399" cy=".097" r="1" />
                <path d="M.472.128C.478.11.472.09.459.086.445.083.429.095.422.113.416.132.422.15.436.155.449.159.465.147.472.128z" />
                <path d="M.47.157C.472.157.497.12.516.102.528.09.56.078.56.078.56.072.541.057.521.057.51.057.498.062.491.072L.488.057S.472.06.464.08C.457.102.462.134.462.134S.465.15.471.157z" />
                <path d="M0.423 0.094L0.43 0.148 0.511 0.16 0.523 0.15 0.52 0.131 0.459 0.06 0.423 0.094" />
                <path d="M.529.097C.518.085.494.088.476.103.458.118.452.141.464.153.476.166.5.163.518.147.536.132.54.109.528.097z" />
              </g>
              <g transform="translate(1 6) translate(1 1.173) translate(.192) translate(.085 .256)">
                <path
                  fill="#AD1519"
                  fillRule="nonzero"
                  d="M0.003 0.101L0.034 0.051 0.099 0.064 0.061 0.12 0.003 0.101"
                />
                <path
                  fill="#058E6E"
                  fillRule="nonzero"
                  d="M.09.102l-.033.01C.047.116.039.105.038.088.038.07.043.055.051.052l.034-.01L.12.03C.129.029.136.04.138.056.138.073.133.089.125.09L.09.1"
                />
                <circle
                  cx=".151"
                  cy=".069"
                  r="1"
                  fill="#FFF"
                  fillRule="nonzero"
                />
                <path
                  fill="#AD1519"
                  fillRule="nonzero"
                  d="M.186.095H.15C.142.095.137.081.137.065c0-.018.005-.032.012-.032h.075c.007 0 .013.014.013.031S.23.095.224.095H.186"
                />
                <circle
                  cx=".257"
                  cy=".069"
                  r="1"
                  fill="#FFF"
                  fillRule="nonzero"
                />
                <path
                  fill="#058E6E"
                  fillRule="nonzero"
                  d="M.294.102l.033.01C.336.116.344.105.346.088.346.07.34.055.332.052L.298.042.264.03C.255.029.247.04.246.056.244.073.25.089.259.09L.294.1"
                />
                <path
                  fill="#AD1519"
                  fillRule="nonzero"
                  d="M.401.105L.376.052.309.058.341.117.401.105M.163.16C.112.16.065.144.03.112.065.08.112.06.163.06c.052 0 .1.02.135.052C.263.144.215.16.163.16z"
                />
                <path d="M.227.162v-.1m-.013.1l.001-.1m-.01.1v-.1M.198.161L.198.061M.191.161L.191.061M.184.161L.184.061M.177.161L.177.061M.171.161L.171.061M.16.163l-.002-.1m.007.099v-.1M.148.163v-.1m.006.1v-.1M.134.16V.069m.005.095V.065m.004.099v-.1M.129.159L.129.069M.124.156L.124.071M.119.153L.119.075M.109.145L.108.083M.114.15V.08M.103.141L.103.086M.098.137L.098.091M.093.132L.093.096M.088.128L.088.101M.082.121L.082.108" />
              </g>
            </g>
            <g>
              <g fillRule="nonzero">
                <path
                  fill="#005BBF"
                  d="M.667.062C.634.062.605.054.583.042.563.028.533.021.501.021S.44.028.418.041C.396.053.367.061.334.061.301.062.272.054.25.04.23.028.2.021.17.021c-.033 0-.062.007-.083.02C.065.054.035.062.003.062v.06C.035.121.065.111.087.1.108.087.137.08.169.08.2.08.23.087.25.1.272.111.301.12.334.12c.033 0 .062-.008.084-.02C.439.086.468.08.5.08.533.08.562.087.583.1.605.113.634.12.667.12V.062z"
                  transform="translate(1 6) translate(1 1.173) translate(.107 .341) translate(0 2.176)"
                />
                <path
                  fill="#CCC"
                  d="M.667.114C.634.114.605.106.583.093.563.08.533.073.501.073S.44.08.418.092C.396.106.367.113.334.113.301.114.272.106.25.093.23.08.2.072.17.072.136.072.107.08.086.092.065.105.035.114.003.114v.058C.035.172.065.164.087.151.108.138.137.13.169.13.2.131.23.139.25.151c.022.013.051.021.084.021.033 0 .062-.008.084-.02C.439.138.468.13.5.13c.032 0 .061.008.082.02.022.013.051.021.084.021V.114"
                  transform="translate(1 6) translate(1 1.173) translate(.107 .341) translate(0 2.176)"
                />
                <path
                  fill="#005BBF"
                  d="M.667.165C.634.165.605.157.583.145.563.131.533.123.501.123S.44.132.418.144C.396.157.367.165.334.165.301.165.272.156.25.143.23.131.2.123.17.123c-.033 0-.062.008-.083.02C.065.158.035.166.003.166v.059C.035.224.065.215.087.202.108.19.137.182.169.182.2.183.23.19.25.203c.022.013.051.022.084.022.033 0 .062-.008.084-.021C.439.19.468.183.5.183c.032 0 .061.007.082.02.022.013.051.02.084.02V.166"
                  transform="translate(1 6) translate(1 1.173) translate(.107 .341) translate(0 2.176)"
                />
                <path
                  fill="#CCC"
                  d="M.667.275C.634.275.605.267.583.255.563.241.533.234.501.234S.44.241.418.254C.396.266.367.274.334.274.301.275.272.266.25.253.23.241.2.234.17.234c-.033 0-.062.007-.083.02C.065.267.035.275.003.275V.217C.035.217.065.208.087.195c.021-.013.05-.02.082-.02.031 0 .06.008.081.02.022.013.051.021.084.021.033 0 .062-.007.084-.02C.439.183.468.176.5.176c.032 0 .061.007.082.02.022.013.051.02.084.02v.06"
                  transform="translate(1 6) translate(1 1.173) translate(.107 .341) translate(0 2.176)"
                />
                <path
                  fill="#005BBF"
                  d="M.667.327C.634.327.605.319.583.306.563.293.533.286.501.286S.44.292.418.305C.396.318.367.326.334.326.301.327.272.319.25.306.23.293.2.285.17.285c-.033 0-.062.008-.083.02C.065.318.035.327.003.327V.268C.035.268.065.26.087.247c.021-.013.05-.02.082-.02C.2.227.23.234.25.246c.022.013.051.022.084.022C.367.268.396.26.418.247.439.234.468.227.5.227c.032 0 .061.007.082.02.022.013.051.021.084.021v.059z"
                  transform="translate(1 6) translate(1 1.173) translate(.107 .341) translate(0 2.176)"
                />
              </g>
              <g fill="#C8B100" fillRule="nonzero">
                <path
                  d="M.062.038c.001.006.003.012.003.02 0 .044-.027.08-.06.08h.49C.46.138.435.102.435.058l.001-.02C.434.04.43.04.427.04H.071C.068.04.065.04.062.038z"
                  transform="translate(1 6) translate(1 1.173) translate(.107 .341) translate(.085 1.984)"
                />
                <path
                  d="M.071.006h.356C.44.006.45.028.45.056c0 .027-.01.05-.022.05H.071C.059.106.049.083.049.056c0-.028.01-.05.022-.05zM.006.232L.494.232.494.107.006.107z"
                  transform="translate(1 6) translate(1 1.173) translate(.107 .341) translate(.085 1.984)"
                />
              </g>
              <path
                fill="#CCC"
                fillRule="nonzero"
                d="M0.161 1.969L0.508 1.969 0.508 0.271 0.161 0.271z"
                transform="translate(1 6) translate(1 1.173) translate(.107 .341)"
              />
              <path
                d="M.447.273v1.695M.487.273v1.695"
                transform="translate(1 6) translate(1 1.173) translate(.107 .341)"
              />
              <g fill="#C8B100" fillRule="nonzero">
                <path
                  d="M.012.136L.488.136.488.011.012.011zM.062.262C.065.26.067.26.071.26h.356c.004 0 .007 0 .01.003C.425.255.416.236.416.213c0-.023.01-.043.022-.05l-.01.003H.07c-.004 0-.007 0-.01-.003l.002.001c.013.007.02.027.02.049 0 .02-.008.042-.02.05z"
                  transform="translate(1 6) translate(1 1.173) translate(.107 .341) translate(.085)"
                />
                <path
                  d="M.071.217h.356C.44.217.45.24.45.267c0 .028-.01.05-.022.05H.071C.059.317.049.295.049.267c0-.027.01-.05.022-.05z"
                  transform="translate(1 6) translate(1 1.173) translate(.107 .341) translate(.085)"
                />
                <path
                  d="M.071.136h.356C.44.136.45.158.45.186c0 .027-.01.05-.022.05H.071C.059.236.049.213.049.186c0-.028.01-.05.022-.05z"
                  transform="translate(1 6) translate(1 1.173) translate(.107 .341) translate(.085)"
                />
              </g>
            </g>
            <g fill="#AD1519" fillRule="nonzero">
              <path
                d="M.16.91C.11.936.079.965.084.98c.002.013.018.023.04.037.034.024.055.067.039.087.028-.023.046-.057.046-.096C.21.968.19.932.16.91zM.969.266C.893.235.764.212.617.206.566.208.509.213.45.223.243.256.085.339.098.407v.005S.022.237.02.23C.006.156.18.064.41.025.484.013.554.008.615.01c.147 0 .275.019.353.048v.209"
                transform="translate(1 6) translate(1 1.173) translate(0 .981)"
              />
              <path
                d="M.267.48C.171.472.105.446.097.406.093.375.125.339.183.307.208.31.237.313.268.313V.48M.615.35c.06.009.105.024.128.042l.002.004c.01.021-.042.068-.13.12V.35"
                transform="translate(1 6) translate(1 1.173) translate(0 .981)"
              />
              <path
                d="M.052.807C.042.78.136.725.269.677.329.654.379.631.44.604.625.523.761.43.745.395L.743.393C.753.4.768.568.768.568.785.599.66.69.491.772.436.798.32.841.268.86.17.893.075.956.084.98L.052.807z"
                transform="translate(1 6) translate(1 1.173) translate(0 .981)"
              />
            </g>
            <g>
              <path
                fill="#AD1519"
                fillRule="nonzero"
                d="M.253.201S.237.218.225.22C.215.222.2.21.2.21S.19.22.177.222C.164.226.147.21.147.21S.134.226.124.23C.113.234.1.225.1.225S.095.233.086.238C.082.24.076.237.076.237L.063.229.048.214.035.208.028.186.027.173C.024.16.045.143.076.137.093.133.109.133.12.137.132.126.158.118.188.118c.027 0 .052.006.065.015C.266.124.29.119.317.119c.03 0 .056.007.068.017.012-.003.027-.003.045 0C.46.145.48.16.479.174L.477.186.47.208.457.214.442.229.43.237S.424.24.42.238C.41.234.406.225.406.225S.393.234.382.23C.37.226.359.21.359.21S.34.225.329.222C.316.22.306.21.306.21S.29.222.28.22C.268.219.253.202.253.202z"
                transform="translate(1 6) translate(1 1.173) translate(3.37 .021)"
              />
              <g transform="translate(1 6) translate(1 1.173) translate(3.37 .021) translate(.213)">
                <circle
                  cx=".059"
                  cy=".119"
                  r="1"
                  fill="#C8B100"
                  fillRule="nonzero"
                />
                <circle
                  cx=".076"
                  cy=".122"
                  r="1"
                  fill="#C8B100"
                  fillRule="nonzero"
                />
                <circle
                  cx=".069"
                  cy=".094"
                  r="1"
                  fill="#C8B100"
                  fillRule="nonzero"
                />
                <path
                  fill="#C8B100"
                  fillRule="nonzero"
                  d="M0.113 0.085L0.113 0.104 0.013 0.104 0.013 0.085 0.05 0.085 0.05 0.042 0.025 0.042 0.025 0.023 0.05 0.023 0.05 0.004 0.074 0.004 0.074 0.023 0.098 0.023 0.098 0.042 0.074 0.042 0.074 0.085 0.113 0.085"
                />
                <path d="M.084.046c.024.007.039.031.035.056C.115.127.093.146.069.145.042.145.022.125.018.1.018.075.034.051.058.045" />
              </g>
              <g transform="translate(1 6) translate(1 1.173) translate(3.37 .021) translate(0 .043)">
                <path d="M.03.165C.029.156.026.147.026.137c0-.04.03-.072.068-.072.012 0 .023.003.032.009M.139.143C.135.134.132.124.132.114c0-.04.028-.071.062-.071.014 0 .028.006.038.015M.374.143C.378.134.38.123.38.113.38.074.353.043.32.043.304.043.29.049.28.058M.484.165C.487.156.489.147.489.137c0-.04-.03-.072-.067-.072C.41.065.398.068.389.074" />
                <circle cx=".053" cy=".162" r="1" />
                <circle cx=".056" cy=".128" r="1" />
                <circle cx=".078" cy=".103" r="1" />
                <circle cx=".107" cy=".089" r="1" />
                <circle cx=".137" cy=".09" r="1" />
                <circle
                  cx=".156"
                  cy=".128"
                  r="1"
                  fill="#FFF"
                  fillRule="nonzero"
                />
                <circle cx=".162" cy=".096" r="1" />
                <circle cx=".186" cy=".076" r="1" />
                <circle cx=".216" cy=".066" r="1" />
                <circle cx=".247" cy=".067" r="1" />
                <circle cx=".338" cy=".067" r="1" />
                <circle cx=".369" cy=".066" r="1" />
                <circle cx=".399" cy=".076" r="1" />
                <circle cx=".423" cy=".096" r="1" />
                <circle
                  cx=".428"
                  cy=".128"
                  r="1"
                  fill="#FFF"
                  fillRule="nonzero"
                />
                <circle cx=".447" cy=".09" r="1" />
                <circle cx=".478" cy=".089" r="1" />
                <circle cx=".507" cy=".103" r="1" />
                <circle cx=".529" cy=".128" r="1" />
                <circle cx=".532" cy=".162" r="1" />
              </g>
              <g
                fill="#C8B100"
                fillRule="nonzero"
                transform="translate(1 6) translate(1 1.173) translate(3.37 .021) translate(.004 .128)"
              >
                <path d="M.098.186C.093.166.085.146.085.146.127.126.185.112.25.112s.123.013.164.034L.402.18C.398.191.394.21.394.21.356.19.308.18.249.18.189.18.132.193.102.212L.097.186" />
                <path d="M.249.251c.052 0 .109-.014.13-.024C.393.22.401.21.4.196.4.19.396.184.392.18.361.163.305.151.25.151c-.056 0-.112.012-.143.03C.102.184.099.19.098.196.096.209.105.22.118.227c.022.01.08.024.131.024z" />
                <path d="M.416.149L.403.124S.391.14.376.135C.36.13.356.091.356.091S.339.12.326.119C.31.116.301.091.301.091S.287.114.274.11C.26.11.248.075.248.075S.235.11.221.114C.208.115.197.087.197.087S.191.116.175.122C.158.128.143.093.143.093S.133.127.122.135C.111.144.096.123.096.123L.09.143C.09.15.085.15.085.15l.004.022C.129.147.186.131.249.131c.064 0 .121.016.163.043L.416.149z" />
                <path d="M.25.053l.005.002v.012c0 .02.01.035.023.035.01 0 .02-.01.023-.024L.304.065V.08c.002.017.013.03.024.03.014 0 .024-.016.024-.036V.07L.359.058l.004.014-.002.015c0 .019.01.034.023.034C.392.12.399.115.403.106l.004-.01v.012c0 .011.003.022.01.024 0 0 .009 0 .02-.013C.448.106.454.094.454.094l.001.014s-.01.028-.02.036C.428.15.42.154.414.153.406.15.401.143.4.133.395.137.389.14.383.14.369.14.357.128.353.11.345.121.337.128.327.128.317.128.307.12.3.108.295.119.287.124.278.124.266.123.255.113.249.1.243.114.233.123.221.123.21.123.203.118.197.109.191.12.181.128.171.128.16.128.15.122.146.111.14.128.129.14.116.14.108.14.102.137.098.133.096.143.09.15.084.153.078.155.07.149.064.144.054.136.042.108.042.108L.044.094S.05.106.06.12c.011.014.02.013.02.013C.087.13.09.119.09.108V.096l.005.01C.1.115.106.12.114.12.127.12.137.106.137.087c0-.005 0-.01-.002-.015L.139.058l.007.011v.004c0 .02.01.035.024.035.012 0 .022-.012.023-.03L.194.066l.004.013C.2.092.21.102.22.102.233.102.244.086.244.067L.243.055.249.053z" />
                <path d="M.249.136C.185.136.127.161.085.2.083.202.08.196.078.188.078.18.08.17.082.167.124.126.183.1.25.1s.125.026.167.067C.419.169.421.179.42.188.419.196.416.202.413.2.37.16.313.137.249.136zM.091.157S.066.12.048.102C.034.09.002.078.002.078c0-.006.019-.021.04-.021.011 0 .023.005.03.015L.073.057S.09.06.097.08c.008.021.004.053.004.053S.097.15.09.157z" />
                <path d="M0.134 0.094L0.128 0.148 0.046 0.16 0.034 0.15 0.036 0.131 0.098 0.06 0.134 0.094" />
                <path d="M.045.097C.057.085.08.088.098.103c.018.015.024.038.012.05C.098.166.074.163.057.147.039.132.033.109.045.097z" />
                <path d="M.105.128C.1.11.105.09.118.086c.014-.003.03.009.037.027.006.019 0 .038-.014.042C.128.159.112.147.105.128z" />
                <path d="M0.1 0.109L0.128 0.15 0.195 0.093 0.2 0.075 0.19 0.061 0.113 0.05 0.1 0.109" />
                <path d="M0.158 0.016L0.115 0.05 0.171 0.111 0.185 0.116 0.196 0.107 0.215 0.033 0.158 0.016" />
                <path d="M0.239 0.083L0.225 0.138 0.149 0.127 0.139 0.113 0.145 0.094 0.211 0.038 0.239 0.083" />
                <circle cx=".178" cy=".097" r="1" />
                <path d="M.208.105C.205.085.216.068.23.066.243.064.257.079.26.099.263.118.252.136.238.137.225.139.211.124.208.105z" />
                <path d="M0.209 0.087L0.23 0.135 0.301 0.099 0.309 0.084 0.301 0.067 0.23 0.035 0.209 0.087" />
                <path d="M0.28 0.003L0.23 0.029 0.268 0.096 0.28 0.103 0.293 0.096 0.33 0.029 0.28 0.003" />
                <path d="M0.349 0.087L0.328 0.135 0.257 0.099 0.249 0.084 0.257 0.067 0.328 0.035 0.349 0.087" />
                <circle cx=".289" cy=".087" r="1" />
                <path d="M.37.105C.37.085.36.068.346.066.333.064.32.079.317.099.315.118.324.136.338.137.352.139.366.124.37.105z" />
                <path d="M0.32 0.083L0.334 0.138 0.41 0.127 0.42 0.113 0.414 0.094 0.348 0.038 0.32 0.083" />
                <path d="M0.406 0.016L0.449 0.05 0.394 0.111 0.38 0.116 0.369 0.107 0.349 0.033 0.406 0.016" />
                <path d="M0.459 0.109L0.432 0.15 0.365 0.093 0.359 0.075 0.37 0.061 0.446 0.05 0.459 0.109" />
                <circle cx=".399" cy=".097" r="1" />
                <path d="M.472.128C.478.11.472.09.459.086.445.083.429.095.422.113.416.132.422.15.436.155.449.159.465.147.472.128z" />
                <path d="M.47.157C.472.157.497.12.516.102.528.09.56.078.56.078.56.072.541.057.521.057.51.057.498.062.491.072L.488.057S.472.06.464.08C.457.102.462.134.462.134S.465.15.471.157z" />
                <path d="M0.423 0.094L0.43 0.148 0.511 0.16 0.523 0.15 0.52 0.131 0.459 0.06 0.423 0.094" />
                <path d="M.529.097C.518.085.494.088.476.103.458.118.452.141.464.153.476.166.5.163.518.147.536.132.54.109.528.097z" />
              </g>
              <g transform="translate(1 6) translate(1 1.173) translate(3.37 .021) translate(.089 .235)">
                <path
                  fill="#AD1519"
                  fillRule="nonzero"
                  d="M0.003 0.101L0.034 0.051 0.099 0.064 0.061 0.12 0.003 0.101"
                />
                <path
                  fill="#058E6E"
                  fillRule="nonzero"
                  d="M.09.102l-.033.01C.047.116.039.105.038.088.038.07.043.055.051.052l.034-.01L.12.03C.129.029.136.04.138.056.138.073.133.089.125.09L.09.1"
                />
                <circle
                  cx=".151"
                  cy=".069"
                  r="1"
                  fill="#FFF"
                  fillRule="nonzero"
                />
                <path
                  fill="#AD1519"
                  fillRule="nonzero"
                  d="M.186.095H.15C.142.095.137.081.137.065c0-.018.005-.032.012-.032h.075c.007 0 .013.014.013.031S.23.095.224.095H.186"
                />
                <circle
                  cx=".257"
                  cy=".069"
                  r="1"
                  fill="#FFF"
                  fillRule="nonzero"
                />
                <path
                  fill="#058E6E"
                  fillRule="nonzero"
                  d="M.294.102l.033.01C.336.116.344.105.346.088.346.07.34.055.332.052L.298.042.264.03C.255.029.247.04.246.056.244.073.25.089.259.09L.294.1"
                />
                <path
                  fill="#AD1519"
                  fillRule="nonzero"
                  d="M.401.105L.376.052.309.058.341.117.401.105M.163.16C.112.16.065.144.03.112.065.08.112.06.163.06c.052 0 .1.02.135.052C.263.144.215.16.163.16z"
                />
                <path d="M.227.162v-.1m-.013.1l.001-.1m-.01.1v-.1M.198.161L.198.061M.191.161L.191.061M.184.161L.184.061M.177.161L.177.061M.171.161L.171.061M.16.163l-.002-.1m.007.099v-.1M.148.163v-.1m.006.1v-.1M.134.16V.069m.005.095V.065m.004.099v-.1M.129.159L.129.069M.124.156L.124.071M.119.153L.119.075M.109.145L.108.083M.114.15V.08M.103.141L.103.086M.098.137L.098.091M.093.132L.093.096M.088.128L.088.101M.082.121L.082.108" />
              </g>
            </g>
            <g>
              <g fillRule="nonzero">
                <path
                  fill="#005BBF"
                  d="M.667.062C.634.062.605.054.583.042.563.028.533.021.501.021S.44.028.418.041C.396.053.367.061.334.061.301.062.272.054.25.04.23.028.2.021.17.021c-.033 0-.062.007-.083.02C.065.054.035.062.003.062v.06C.035.121.065.111.087.1.108.087.137.08.169.08.2.08.23.087.25.1.272.111.301.12.334.12c.033 0 .062-.008.084-.02C.439.086.468.08.5.08.533.08.562.087.583.1.605.113.634.12.667.12V.062z"
                  transform="translate(1 6) translate(1 1.173) translate(3.289 .341) translate(0 2.176)"
                />
                <path
                  fill="#CCC"
                  d="M.667.114C.634.114.605.106.583.093.563.08.533.073.501.073S.44.08.418.092C.396.106.367.113.334.113.301.114.272.106.25.093.23.08.2.072.17.072.136.072.107.08.086.092.065.105.035.114.003.114v.058C.035.172.065.164.087.151.108.138.137.13.169.13.2.131.23.139.25.151c.022.013.051.021.084.021.033 0 .062-.008.084-.02C.439.138.468.13.5.13c.032 0 .061.008.082.02.022.013.051.021.084.021V.114"
                  transform="translate(1 6) translate(1 1.173) translate(3.289 .341) translate(0 2.176)"
                />
                <path
                  fill="#005BBF"
                  d="M.667.165C.634.165.605.157.583.145.563.131.533.123.501.123S.44.132.418.144C.396.157.367.165.334.165.301.165.272.156.25.143.23.131.2.123.17.123c-.033 0-.062.008-.083.02C.065.158.035.166.003.166v.059C.035.224.065.215.087.202.108.19.137.182.169.182.2.183.23.19.25.203c.022.013.051.022.084.022.033 0 .062-.008.084-.021C.439.19.468.183.5.183c.032 0 .061.007.082.02.022.013.051.02.084.02V.166"
                  transform="translate(1 6) translate(1 1.173) translate(3.289 .341) translate(0 2.176)"
                />
                <path
                  fill="#CCC"
                  d="M.667.275C.634.275.605.267.583.255.563.241.533.234.501.234S.44.241.418.254C.396.266.367.274.334.274.301.275.272.266.25.253.23.241.2.234.17.234c-.033 0-.062.007-.083.02C.065.267.035.275.003.275V.217C.035.217.065.208.087.195c.021-.013.05-.02.082-.02.031 0 .06.008.081.02.022.013.051.021.084.021.033 0 .062-.007.084-.02C.439.183.468.176.5.176c.032 0 .061.007.082.02.022.013.051.02.084.02v.06"
                  transform="translate(1 6) translate(1 1.173) translate(3.289 .341) translate(0 2.176)"
                />
                <path
                  fill="#005BBF"
                  d="M.667.327C.634.327.605.319.583.306.563.293.533.286.501.286S.44.292.418.305C.396.318.367.326.334.326.301.327.272.319.25.306.23.293.2.285.17.285c-.033 0-.062.008-.083.02C.065.318.035.327.003.327V.268C.035.268.065.26.087.247c.021-.013.05-.02.082-.02C.2.227.23.234.25.246c.022.013.051.022.084.022C.367.268.396.26.418.247.439.234.468.227.5.227c.032 0 .061.007.082.02.022.013.051.021.084.021v.059z"
                  transform="translate(1 6) translate(1 1.173) translate(3.289 .341) translate(0 2.176)"
                />
              </g>
              <g fill="#C8B100" fillRule="nonzero">
                <path
                  d="M.062.038c.001.006.003.012.003.02 0 .044-.027.08-.06.08h.49C.46.138.435.102.435.058l.001-.02C.434.04.43.04.427.04H.071C.068.04.065.04.062.038z"
                  transform="translate(1 6) translate(1 1.173) translate(3.289 .341) translate(.085 1.984)"
                />
                <path
                  d="M.071.006h.356C.44.006.45.028.45.056c0 .027-.01.05-.022.05H.071C.059.106.049.083.049.056c0-.028.01-.05.022-.05zM.006.232L.494.232.494.107.006.107z"
                  transform="translate(1 6) translate(1 1.173) translate(3.289 .341) translate(.085 1.984)"
                />
              </g>
              <path
                fill="#CCC"
                fillRule="nonzero"
                d="M0.161 1.969L0.508 1.969 0.508 0.271 0.161 0.271z"
                transform="translate(1 6) translate(1 1.173) translate(3.289 .341)"
              />
              <path
                d="M.447.273v1.695M.487.273v1.695"
                transform="translate(1 6) translate(1 1.173) translate(3.289 .341)"
              />
              <g fill="#C8B100" fillRule="nonzero">
                <path
                  d="M.012.136L.488.136.488.011.012.011zM.062.262C.065.26.067.26.071.26h.356c.004 0 .007 0 .01.003C.425.255.416.236.416.213c0-.023.01-.043.022-.05l-.01.003H.07c-.004 0-.007 0-.01-.003l.002.001c.013.007.02.027.02.049 0 .02-.008.042-.02.05z"
                  transform="translate(1 6) translate(1 1.173) translate(3.289 .341) translate(.085)"
                />
                <path
                  d="M.071.217h.356C.44.217.45.24.45.267c0 .028-.01.05-.022.05H.071C.059.317.049.295.049.267c0-.027.01-.05.022-.05z"
                  transform="translate(1 6) translate(1 1.173) translate(3.289 .341) translate(.085)"
                />
                <path
                  d="M.071.136h.356C.44.136.45.158.45.186c0 .027-.01.05-.022.05H.071C.059.236.049.213.049.186c0-.028.01-.05.022-.05z"
                  transform="translate(1 6) translate(1 1.173) translate(3.289 .341) translate(.085)"
                />
              </g>
            </g>
            <g fill="#AD1519" fillRule="nonzero">
              <path
                d="M.16.91C.11.936.079.965.084.98c.002.013.018.023.04.037.034.024.055.067.039.087.028-.023.046-.057.046-.096C.21.968.19.932.16.91zM.969.266C.893.235.764.212.617.206.566.208.509.213.45.223.243.256.085.339.098.407v.005S.022.237.02.23C.006.156.18.064.41.025.484.013.554.008.615.01c.147 0 .275.019.353.048v.209"
                transform="translate(1 6) translate(1 1.173) matrix(-1 0 0 1 4.065 .981)"
              />
              <path
                d="M.267.48C.171.472.105.446.097.406.093.375.125.339.183.307.208.31.237.313.268.313V.48M.615.35c.06.009.105.024.128.042l.002.004c.01.021-.042.068-.13.12V.35"
                transform="translate(1 6) translate(1 1.173) matrix(-1 0 0 1 4.065 .981)"
              />
              <path
                d="M.052.807C.042.78.136.725.269.677.329.654.379.631.44.604.625.523.761.43.745.395L.743.393C.753.4.768.568.768.568.785.599.66.69.491.772.436.798.32.841.268.86.17.893.075.956.084.98L.052.807z"
                transform="translate(1 6) translate(1 1.173) matrix(-1 0 0 1 4.065 .981)"
              />
            </g>
            <g fill="#C8B100" fillRule="nonzero">
              <path
                d="M.073.163C.115.148.143.13.13.096.12.075.1.071.066.083L.01.103l.052.13.017-.008L.096.22.073.163zM.048.106l.03-.01C.103.09.13.1.143.127c.01.02.007.041-.022.056-.009.005-.02.009-.03.012L.048.106M.209.047L.19.052.172.055l.03.134.093-.02L.292.163V.153C.274.158.256.163.235.167L.209.047M.396.163C.413.114.435.068.456.02L.444.022H.433C.422.056.408.09.393.124.375.092.356.061.341.028L.32.031H.297C.324.075.35.12.375.164l.01-.002h.01M.591.06l.01-.02C.597.037.582.03.564.028.525.023.503.04.5.063.495.112.571.108.567.14.566.153.551.159.536.157.519.156.506.146.504.132H.499l-.01.024C.5.163.515.167.529.169.566.173.596.157.598.13.606.086.529.083.532.056.532.045.54.037.56.039c.014.002.023.01.027.02H.59M3.142.17c.014-.05.03-.097.047-.146l-.011.002-.012.001c-.008.035-.018.07-.03.105-.02-.03-.043-.06-.06-.091l-.022.004-.022.002.09.126.01-.002h.01M3.276.025h-.04L3.235.16l.1.002-.002-.01.002-.008-.06.002.002-.122M3.424.047c.016.001.03.004.045.007V.045L3.47.037 3.34.026v.009L3.34.043l.047.001-.011.123h.018l.02.003.01-.123M3.478.182l.018.003.018.005.016-.063h.002l.01.026.02.047.022.004.022.006-.007-.014C3.59.175 3.578.153 3.57.13c.024.001.042-.007.047-.026C3.619.09 3.614.08 3.601.072c-.009-.007-.027-.01-.039-.013L3.51.048l-.032.134m.081-.116c.033.007.073.01.073.042 0 .008-.002.013-.003.018-.01.036-.043.049-.097.035l.027-.095M3.724.223c0 .015-.004.03-.006.045l.019.01.018.01.013-.154L3.759.13 3.751.125l-.136.086.011.006.01.006.037-.028.051.028zM3.686.216l.1-.057-.012.1-.088-.043"
                transform="translate(1 6) translate(1 1.173) translate(.17 1.003)"
              />
            </g>
          </g>
          <g>
            <path
              fill="#AD1519"
              fillRule="nonzero"
              d="M1.166.591c.142 0 .268.021.35.054.047.021.11.037.18.046.052.007.102.009.145.005.059-.001.143.016.227.053.07.031.128.069.166.105l-.033.03-.01.084-.092.105-.045.04-.109.086-.056.005-.016.048-.702-.083-.705.083-.017-.048-.055-.005-.109-.087-.046-.039L.148.968.138.884.105.854C.143.818.2.78.27.749.355.712.439.695.497.696.541.7.591.698.644.691.713.681.776.666.823.645.905.612 1.024.59 1.166.59z"
              transform="translate(1 6) translate(1.853)"
            />
            <g
              fillRule="nonzero"
              transform="translate(1 6) translate(1.853) translate(.064)"
            >
              <path
                fill="#C8B100"
                d="M.583.777l.03.024.044-.073C.61.698.576.648.576.59L.577.57C.582.478.695.402.837.402c.075 0 .142.02.19.053 0-.015.002-.027.004-.04C.979.384.91.365.838.365.673.365.544.46.538.57v.02c0 .058.026.111.069.148L.583.777"
              />
              <path
                fill="#C8B100"
                d="M.585.778C.53.736.495.678.495.616.494.544.54.48.612.436.57.473.543.519.538.57v.02c0 .058.026.111.069.148l-.022.04"
              />
              <path
                fill="#C8B100"
                d="M.09.851C.058.816.039.771.039.721c0-.03.007-.06.02-.085C.103.543.246.475.415.475c.046 0 .09.005.131.014-.009.01-.016.02-.023.032C.49.514.454.51.416.51.261.51.131.57.093.651.083.672.078.696.078.72c0 .05.023.094.06.125L.08.936.051.912.09.851z"
              />
              <path
                fill="#C8B100"
                d="M.147.544C.107.569.076.6.058.636.046.662.04.69.04.72c0 .05.02.096.05.131L.057.906C.023.864.004.816.004.763c0-.09.057-.168.143-.22zM1.11.347c.038 0 .07.025.078.058.005.03.008.063.009.099v.024c.002.075.012.141.028.182L1.11.82.994.71c.016-.04.026-.107.028-.182V.515.504c.001-.036.004-.07.01-.099.007-.033.04-.058.078-.058z"
              />
              <path
                fill="#C8B100"
                d="M1.11.383c.02 0 .036.012.04.03.005.027.008.06.009.093v.023c.001.07.012.133.026.171L1.11.772 1.034.7c.014-.038.025-.1.026-.171V.516v-.01c.001-.034.004-.066.009-.094.004-.017.022-.03.041-.03zM1.636.777l-.03.024-.044-.073c.048-.03.082-.08.082-.139 0-.006 0-.013-.002-.02-.004-.092-.117-.168-.26-.168-.074 0-.141.02-.189.053 0-.015-.002-.027-.004-.04.052-.03.12-.049.193-.049.164 0 .293.094.3.205v.02c0 .058-.027.111-.07.148l.024.039"
              />
              <path
                fill="#C8B100"
                d="M1.634.778c.056-.042.091-.1.091-.162 0-.072-.047-.136-.119-.18.045.036.071.082.075.134l.001.02c0 .058-.027.111-.07.148l.022.04"
              />
              <path
                fill="#C8B100"
                d="M2.13.851c.031-.035.05-.08.05-.13 0-.03-.007-.06-.019-.085-.046-.093-.188-.161-.357-.161-.047 0-.09.005-.132.014.01.01.017.02.024.032.033-.007.07-.01.108-.01.155 0 .284.06.322.141.01.02.015.044.015.068 0 .05-.023.094-.06.125l.057.091.03-.024L2.13.851z"
              />
              <path
                fill="#C8B100"
                d="M2.072.544c.041.025.072.057.09.092.011.026.018.054.018.084 0 .05-.019.096-.05.131l.034.055c.032-.042.051-.09.051-.143 0-.09-.057-.168-.143-.22z"
              />
              <circle cx="1.11" cy=".262" r="1" fill="#005BBF" />
              <path
                fill="#C8B100"
                d="M1.086.012V.06h-.052v.049h.052V.25H1.02c-.001.004-.005.008-.005.012 0 .013.002.025.007.035l.001.001h.173c.006-.011.008-.023.008-.036 0-.004-.004-.008-.004-.012h-.064V.109h.052v-.05h-.052V.013h-.051z"
              />
            </g>
            <g
              fill="#FFF"
              fillRule="nonzero"
              transform="translate(1 6) translate(1.853) translate(0 .299)"
            >
              <circle cx="1.183" cy=".437" r="1" />
              <circle cx="1.183" cy=".361" r="1" />
              <circle cx="1.192" cy=".288" r="1" />
              <circle cx="1.201" cy=".224" r="1" />
              <circle cx="1.205" cy=".164" r="1" />
              <circle cx=".111" cy=".661" r="1" />
              <circle cx=".079" cy=".604" r="1" />
              <circle cx=".057" cy=".539" r="1" />
              <circle cx=".054" cy=".468" r="1" />
              <circle cx=".072" cy=".399" r="1" />
              <circle cx=".108" cy=".336" r="1" />
              <circle cx=".156" cy=".284" r="1" />
              <circle cx=".212" cy=".241" r="1" />
              <circle cx=".278" cy=".206" r="1" />
              <circle cx=".347" cy=".181" r="1" />
              <circle cx=".425" cy=".167" r="1" />
              <circle cx=".498" cy=".163" r="1" />
              <circle cx=".57" cy=".166" r="1" />
              <circle cx=".65" cy=".483" r="1" />
              <circle cx=".61" cy=".426" r="1" />
              <circle cx=".589" cy=".364" r="1" />
              <circle cx=".591" cy=".296" r="1" />
              <circle cx=".606" cy=".228" r="1" />
              <circle cx=".642" cy=".166" r="1" />
              <circle cx=".696" cy=".123" r="1" />
              <circle cx=".76" cy=".088" r="1" />
              <circle cx=".831" cy=".067" r="1" />
              <circle cx=".904" cy=".054" r="1" />
              <circle cx=".976" cy=".055" r="1" />
              <circle cx="1.05" cy=".068" r="1" />
              <circle cx="1.119" cy=".092" r="1" />
              <circle cx="1.281" cy=".092" r="1" />
              <circle cx="1.35" cy=".068" r="1" />
              <circle cx="1.425" cy=".055" r="1" />
              <circle cx="1.496" cy=".054" r="1" />
              <circle cx="1.57" cy=".067" r="1" />
              <circle cx="1.64" cy=".088" r="1" />
              <circle cx="1.704" cy=".123" r="1" />
              <circle cx="1.759" cy=".166" r="1" />
              <circle cx="1.795" cy=".228" r="1" />
              <circle cx="1.809" cy=".296" r="1" />
              <circle cx="1.812" cy=".364" r="1" />
              <circle cx="1.791" cy=".426" r="1" />
              <circle cx="1.751" cy=".483" r="1" />
              <circle cx="1.831" cy=".166" r="1" />
              <circle cx="1.903" cy=".163" r="1" />
              <circle cx="1.976" cy=".167" r="1" />
              <circle cx="2.053" cy=".181" r="1" />
              <circle cx="2.122" cy=".206" r="1" />
              <circle cx="2.189" cy=".241" r="1" />
              <circle cx="2.245" cy=".284" r="1" />
              <circle cx="2.293" cy=".336" r="1" />
              <circle cx="2.329" cy=".399" r="1" />
              <circle cx="2.346" cy=".468" r="1" />
              <circle cx="2.343" cy=".539" r="1" />
              <circle cx="2.322" cy=".604" r="1" />
              <circle cx="2.29" cy=".661" r="1" />
            </g>
            <g
              fillRule="nonzero"
              transform="translate(1 6) translate(1.853) translate(.085 .704)"
            >
              <path
                fill="#C8B100"
                d="M1.091.815C.83.815.595.783.428.733.416.729.409.718.41.706.41.695.416.685.428.681.595.631.83.6 1.09.6c.262 0 .496.032.663.082.012.004.018.014.018.025 0 .012-.006.023-.018.027-.167.05-.401.081-.663.082"
              />
              <path
                fill="#C8B100"
                d="M1.09.6C.824.6.586.632.42.684.434.678.432.66.415.616.395.562.362.565.362.565.547.51.804.475 1.09.475c.286 0 .546.035.73.09 0 0-.032-.003-.053.051-.017.045-.018.062-.004.069C1.596.633 1.354.6 1.089.599"
              />
              <path
                fill="#C8B100"
                d="M1.09.476C.805.476.548.51.363.565.349.569.336.564.332.552S.335.527.347.523C.533.466.797.431 1.091.43c.293 0 .558.036.744.093.012.004.02.017.015.03-.004.01-.017.016-.03.012-.184-.055-.443-.089-.73-.09"
              />
              <path
                fill="#C8B100"
                d="M1.092.251l.027.005c-.005.01-.006.022-.006.035 0 .055.048.099.105.099.047 0 .087-.029.1-.069.002.002.01-.035.014-.035s.004.038.005.038c.007.05.053.084.104.084.058 0 .105-.045.105-.1L1.545.296l.033-.032.018.041c-.008.013-.01.028-.01.044 0 .052.045.094.1.094.035 0 .065-.016.083-.042L1.79.375v.032c0 .033.014.063.046.068 0 0 .037.002.086-.036.049-.039.076-.07.076-.07l.004.038s-.04.063-.085.089c-.024.014-.06.028-.09.024-.03-.005-.053-.03-.064-.059-.022.013-.048.02-.076.02-.06 0-.114-.032-.135-.081-.027.03-.066.048-.11.048-.049 0-.092-.022-.12-.055-.027.025-.063.04-.104.04-.053 0-.1-.026-.126-.065-.027.039-.074.065-.127.065C.925.433.888.418.86.393.834.426.79.448.742.448.697.448.659.429.632.4.61.45.555.482.495.482.468.482.443.474.421.462.409.49.387.514.356.52.327.524.291.51.266.496.222.47.181.407.181.407L.186.369S.213.4.262.439C.31.477.347.475.347.475.38.47.393.44.393.407V.375L.414.4c.018.026.049.042.083.042.056 0 .1-.042.1-.094 0-.016-.002-.03-.01-.044L.606.264l.033.032v.012c0 .055.046.1.104.1C.794.408.84.374.846.324.848.324.847.287.851.286c.004 0 .013.037.014.035.014.04.053.069.1.069.058 0 .105-.044.105-.1 0-.012 0-.023-.005-.034l.027-.005"
              />
              <path
                fill="#C8B100"
                d="M.2.39C.198.384.192.376.185.369.168.354.145.351.135.363L.13.368S.107.324.079.308C.052.295.005.299.005.299c0-.034.027-.062.063-.062C.09.236.11.245.121.26L.126.237s.03.006.043.039c.013.033-.002.08-.002.08S.175.337.185.324C.196.309.224.294.24.287.253.281.268.27.268.27v.031c.027-.004.058 0 .082.01-.01.02-.03.04-.056.05 0 0 .01.007.018.015l.01.01-.028.005C.285.39.255.397.237.396L.2.39"
              />
              <path
                fill="#AD1519"
                d="M.136.367C.152.349.182.353.206.375c.023.021.03.053.014.07C.205.462.174.458.151.437.128.415.121.384.136.367"
              />
              <path
                fill="#FFF"
                d="M.373.403C.362.376.373.349.397.343.422.337.452.354.464.381.475.408.465.435.44.441.415.447.385.43.373.403"
              />
              <path
                fill="#C8B100"
                d="M.579.296C.572.29.566.282.564.273.563.263.564.254.57.246.57.246.55.237.53.232.515.228.488.227.48.227H.455l.006.012.01.016C.446.26.422.278.408.299c.021.015.05.024.077.02 0 0-.003.008-.004.02L.478.35.501.343C.51.34.534.33.547.323.564.31.579.295.579.295"
              />
              <path
                fill="#C8B100"
                d="M.57.078C.591.092.61.116.617.143c0 0 .003-.006.015-.013C.646.123.657.123.657.123L.65.151C.65.16.65.181.644.201.64.22.631.237.631.237.622.229.61.226.597.227.585.23.575.238.57.248c0 0-.014-.012-.026-.03C.532.2.523.18.52.174L.504.15S.514.145.528.148C.543.15.547.154.547.154.544.127.553.1.569.078"
              />
              <path
                fill="#C8B100"
                d="M.64.285C.643.278.645.27.643.26.643.25.638.242.63.236c0 0 .015-.015.032-.027C.675.201.7.192.708.19L.73.181v.013L.724.212C.753.21.78.218.802.233.787.253.764.271.737.278l.01.015.007.012H.729C.721.305.694.305.68.3.659.295.639.286.639.286"
              />
              <circle cx=".609" cy=".272" r="1" fill="#AD1519" />
              <path
                fill="#FFF"
                d="M.827.312C.822.284.841.26.867.258.896.255.922.276.927.303.93.331.913.355.886.357.857.36.831.34.826.312"
              />
              <path
                fill="#C8B100"
                d="M1.056.252C1.049.245 1.045.235 1.045.224c0-.01.004-.02.01-.028 0 0-.018-.014-.04-.024C1 .164.97.159.96.158L.932.153l.005.014.008.02C.914.188.885.204.864.224c.02.02.05.036.081.038 0 0-.004.007-.008.02L.932.295.96.29C.969.289.999.284 1.015.276c.022-.01.041-.023.041-.023"
              />
              <path
                fill="#C8B100"
                d="M1.09.008c.023.02.04.05.042.081 0 0 .004-.006.02-.011.015-.006.027-.004.027-.004l-.012.03c-.004.009-.008.033-.018.055-.01.021-.022.037-.022.037C1.118.186 1.105.18 1.09.18c-.015 0-.027.007-.036.016 0 0-.013-.016-.022-.037-.01-.022-.014-.046-.018-.054l-.012-.03s.012-.003.027.003c.016.005.02.011.02.011.002-.031.018-.061.04-.081"
              />
              <path
                fill="#C8B100"
                d="M1.126.252c.007-.007.01-.017.01-.028 0-.01-.003-.02-.01-.028 0 0 .019-.014.04-.024.017-.008.047-.013.056-.014l.027-.005s0 .004-.004.014c-.004.012-.009.02-.009.02.032.001.061.017.082.037-.02.02-.05.036-.082.038 0 0 .005.007.009.02l.004.014L1.222.29c-.01-.002-.04-.007-.055-.015-.022-.01-.041-.023-.041-.023"
              />
              <circle cx="1.095" cy=".23" r="1" fill="#AD1519" />
              <path
                fill="#FFF"
                d="M1.407.312c.005-.028-.013-.052-.04-.054-.028-.003-.054.018-.059.045-.004.028.014.052.04.054.028.002.054-.018.059-.045"
              />
              <path
                fill="#C8B100"
                d="M1.544.285C1.54.278 1.537.27 1.54.26c.002-.01.007-.017.014-.023 0 0-.014-.015-.031-.027-.013-.008-.039-.017-.046-.02L1.453.181l.001.013.004.018c-.027-.003-.055.006-.076.021.014.02.037.038.064.045l-.01.015-.006.012h.024c.008 0 .035 0 .05-.005.02-.005.04-.014.04-.014"
              />
              <path
                fill="#C8B100"
                d="M1.614.078c-.022.014-.042.038-.049.065 0 0-.003-.006-.015-.013-.013-.007-.023-.007-.023-.007l.005.028c.002.008.002.03.007.05.005.02.013.036.013.036.01-.008.022-.011.034-.01.013.003.023.01.028.02 0 0 .014-.012.026-.03.012-.017.02-.037.024-.044L1.679.15S1.67.145 1.655.148c-.014.002-.019.006-.019.006C1.64.127 1.63.1 1.614.078"
              />
              <path
                fill="#C8B100"
                d="M1.605.296c.007-.006.012-.014.014-.023.002-.01 0-.019-.005-.027 0 0 .02-.009.04-.014.015-.004.042-.005.05-.005h.024l-.006.012c-.005.01-.01.016-.01.016.027.006.05.023.064.044-.02.015-.049.024-.076.02l.004.02.001.012-.023-.008C1.675.34 1.65.33 1.636.323 1.62.31 1.605.295 1.605.295"
              />
              <circle cx="1.582" cy=".272" r="1" fill="#AD1519" />
              <path
                fill="#FFF"
                d="M1.859.403c.011-.027.001-.054-.024-.06-.025-.006-.055.011-.067.038-.011.027-.001.054.024.06.025.006.055-.011.067-.038"
              />
              <path
                fill="#C8B100"
                d="M1.983.39C1.986.384 1.991.376 2 .369c.017-.014.04-.017.05-.005l.004.005s.023-.044.051-.06c.028-.014.075-.01.075-.01 0-.034-.028-.062-.064-.062-.021 0-.041.009-.053.024L2.057.237s-.029.006-.042.039c-.013.033.001.08.001.08s-.007-.02-.018-.033C1.988.309 1.96.294 1.945.287 1.93.281 1.915.27 1.915.27v.013.018c-.027-.004-.058 0-.082.01.01.02.03.04.056.05 0 0-.01.007-.018.015l-.009.01.027.005c.01 0 .04.006.057.005L1.983.39"
              />
              <path
                fill="#AD1519"
                d="M2.074.367c-.015-.018-.046-.014-.07.008-.022.021-.029.053-.014.07.015.017.046.013.07-.008.022-.022.029-.053.014-.07"
              />
            </g>
            <g>
              <path
                fill="#AD1519"
                fillRule="nonzero"
                d="M.728.268C.492.268.278.241.116.198.278.158.492.132.728.132s.45.026.613.068C1.179.24.964.268.728.269z"
                transform="translate(1 6) translate(1.853) translate(.448 1.216)"
              />
              <path
                d="M.936.262V.134M.87.266L.874.13m-.05.138V.129M.785.27L.785.129M.747.27L.747.129M.711.27L.711.129M.675.27L.675.129M.643.27L.643.129M.584.262L.58.135m.032.129V.13M.527.256V.14m.03.12L.553.136M.452.25V.146m.025.105V.143m.025.112V.142M.426.249L.426.149M.401.251L.401.151M.375.255L.375.155M.323.265l-.004-.1m.03.095v-.1M.294.267L.294.167M.268.273L.268.173M.241.277L.241.177M.213.283L.213.183M.183.272L.183.205M.088.23C.253.17.478.132.728.13c.25.001.476.039.641.1"
                transform="translate(1 6) translate(1.853) translate(.448 1.216)"
              />
              <path
                fill="#AD1519"
                fillRule="nonzero"
                d="M0.015 0.143L0.042 0.076 0.115 0.094 0.057 0.176 0.015 0.143"
                transform="translate(1 6) translate(1.853) translate(.448 1.216)"
              />
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M.171.098c0-.028.023-.05.05-.05.028 0 .05.022.05.05 0 .027-.022.05-.05.05-.027 0-.05-.023-.05-.05"
                transform="translate(1 6) translate(1.853) translate(.448 1.216)"
              />
              <path
                fill="#058E6E"
                fillRule="nonzero"
                d="M.376.105l-.05.01C.313.118.301.103.3.081.298.059.307.039.32.037l.05-.01.052-.011C.435.013.447.028.448.05.45.072.441.091.428.094l-.052.01"
                transform="translate(1 6) translate(1.853) translate(.448 1.216)"
              />
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M.524.057c0-.028.022-.05.05-.05.027 0 .05.022.05.05 0 .027-.023.05-.05.05-.028 0-.05-.023-.05-.05"
                transform="translate(1 6) translate(1.853) translate(.448 1.216)"
              />
              <path
                fill="#AD1519"
                fillRule="nonzero"
                d="M.729.102h-.07C.645.102.634.08.634.052c0-.028.01-.05.023-.05H.8c.013 0 .023.022.023.05 0 .028-.01.05-.023.05H.729"
                transform="translate(1 6) translate(1.853) translate(.448 1.216)"
              />
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M.887.057c0-.028.022-.05.05-.05.027 0 .05.022.05.05 0 .027-.023.05-.05.05-.028 0-.05-.023-.05-.05"
                transform="translate(1 6) translate(1.853) translate(.448 1.216)"
              />
              <path
                fill="#058E6E"
                fillRule="nonzero"
                d="M1.08.105l.051.01c.013.003.025-.012.027-.034.001-.022-.008-.042-.02-.044l-.051-.01-.052-.011C1.022.013 1.01.028 1.009.05c-.002.022.008.041.02.044l.052.01"
                transform="translate(1 6) translate(1.853) translate(.448 1.216)"
              />
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M1.239.098c0-.028.022-.05.05-.05.028 0 .05.022.05.05 0 .027-.022.05-.05.05-.028 0-.05-.023-.05-.05"
                transform="translate(1 6) translate(1.853) translate(.448 1.216)"
              />
              <path
                fill="#AD1519"
                fillRule="nonzero"
                d="M1.444 0.143L1.417 0.076 1.344 0.094 1.403 0.176 1.444 0.143"
                transform="translate(1 6) translate(1.853) translate(.448 1.216)"
              />
            </g>
          </g>
          <g>
            <g fillRule="nonzero">
              <path
                fill="#CCC"
                d="M1.077 1.351c-.279 0-.556-.068-.788-.182C.118 1.084.004.913.004.717v-.71h2.142v.71c0 .196-.113.367-.285.452-.232.114-.505.182-.784.182z"
                transform="translate(1 6) translate(.96 1.493) translate(1 1.195)"
              />
              <path
                fill="#FFD691"
                d="M1.129 1.036c.044.013.067.046.067.085 0 .051-.05.09-.113.09-.064 0-.116-.039-.116-.09 0-.038.022-.08.066-.084l-.005-.01-.014-.015s.017-.003.027 0c.01.005.016.01.016.01l.011-.015c.007-.007.015-.012.015-.012s.01.009.013.014c.004.006.006.013.006.013s.009-.008.017-.01c.007-.004.017-.006.017-.006l-.004.014c-.002.005-.003.016-.003.016"
                transform="translate(1 6) translate(.96 1.493) translate(1 1.195)"
              />
              <path
                fill="#058E6E"
                d="M1.073 1.282s-.084-.07-.121-.08c-.047-.013-.1-.003-.123-.004 0 0 .028.024.04.039.011.014.05.043.072.05.07.022.132-.005.132-.005M1.098 1.302s.054-.083.111-.094c.067-.014.111.008.137.018.001 0-.021.015-.033.027s-.042.05-.088.05c-.047.001-.098-.007-.106-.005l-.021.004"
                transform="translate(1 6) translate(.96 1.493) translate(1 1.195)"
              />
              <path
                fill="#AD1519"
                d="M1.097 1.2c-.031-.02-.05-.047-.05-.079 0-.03.019-.059.05-.079.03.02.05.048.05.08 0 .03-.02.059-.05.079"
                transform="translate(1 6) translate(.96 1.493) translate(1 1.195)"
              />
              <path
                fill="#058E6E"
                d="M1.06 1.316s.036-.032.039-.06c.004-.023-.009-.046-.009-.046h.047s.023.025.023.046c0 .022-.01.05-.01.05s-.033.002-.043.004l-.047.006"
                transform="translate(1 6) translate(.96 1.493) translate(1 1.195)"
              />
            </g>
            <g fillRule="nonzero">
              <path
                fill="#AD1519"
                d="M1.073.737c0 .281-.238.509-.534.509-.296 0-.536-.228-.536-.509V.026h1.07v.711"
                transform="translate(1 6) translate(.96 1.493) translate(1 1.173)"
              />
              <path
                fill="#C8B100"
                d="M0 .728c.004.15.064.261.123.334V.007h-.12L0 .727zM.236 1.157c.034.018.08.047.129.059L.362.001H.236v1.156zM.475 1.243c.05.005.086.004.126 0V0H.475v1.242zM.71 1.216c.05-.01.105-.04.13-.056V0H.713L.711 1.217zM.956 1.05c.052-.046.101-.151.12-.272l.002-.777H.953l.003 1.05z"
                transform="translate(1 6) translate(.96 1.493) translate(1 1.173)"
              />
            </g>
            <g fillRule="nonzero">
              <path
                fill="#AD1519"
                d="M3.08.005v.711c0 .28-.24.508-.536.508-.297 0-.537-.227-.537-.508V.005H3.08"
                transform="translate(1 6) translate(.96 1.493) translate(.067 1.195)"
              />
              <path
                fill="#C8B100"
                d="M2.484.536L2.49.528 2.398.427l-.036.015L2.297.37l.021-.031L2.204.21h-.006L2.2.298l.037.011v.095L2.2.413V.5c.017.006.031.02.037.036h.068l.01-.035h.102l.01.035h.058zM2.336.142v.1h.1v-.1h-.1zm-.13.487c.027 0 .049-.022.049-.05 0-.027-.022-.05-.05-.05-.028 0-.05.023-.05.05 0 .028.022.05.05.05zM2.52.37l-.038-.01V.262l.038-.01V.212C2.503.206 2.489.193 2.483.176h-.058l-.01.036h-.101l-.01-.036h-.067c-.001.005-.003.009-.006.013l.115.127.035-.015.066.073-.022.03.09.1L2.52.5V.369zm-.14-.03l-.042.034.058.066.042-.035L2.38.34zm.156.772c-.026-.001-.048-.02-.054-.043-.035-.005-.069-.014-.1-.028l.017-.03c.028.011.057.02.087.023.007-.014.019-.024.034-.03v-.12l-.037-.01V.778l.037-.01V.605L2.517.603l-.085.094.022.03L2.388.8 2.353.785l-.07.079c.011.018.011.042-.003.06.02.023.043.043.069.059l-.018.03c-.03-.018-.058-.042-.08-.068-.02.006-.04.002-.056-.01C2.17.914 2.167.88 2.188.856l.003-.004C2.177.82 2.167.784 2.163.747H2.2c.003.032.01.062.023.091.01-.001.021 0 .031.003l.07-.078-.02-.031.065-.073.035.016L2.49.58 2.485.57h-.059l-.01.036h-.101L2.304.571h-.07C2.23.586 2.217.598 2.2.604v.086h-.037V.605c-.023-.007-.04-.028-.04-.052 0-.025.017-.046.04-.053V.413l-.037-.01V.308l.038-.01V.21c-.023-.007-.04-.028-.04-.052 0-.03.026-.055.059-.055.026 0 .048.015.055.038h.066l.011-.036h.1l.011.036h.058c.007-.022.029-.038.054-.038l.002.178H2.52v.056h.018v.46H2.52v.056h.017v.257zM2.445.733L2.403.698l-.058.066.042.034.058-.065zM2.262.327h-.1v.1h.1v-.1zm.171.31v-.1h-.1v.1h.1zm-.208.14L2.137.77 2.125.674l.087-.012v.054c0 .021.004.041.013.061zM2.199.66l.088.01s.004.06.002.047C2.287.7 2.3.763 2.3.763L2.21.776c-.01-.02-.012-.04-.012-.06V.66zm.23.38l.009-.044C2.405.982 2.375.964 2.348.94l-.026.029c.032.03.068.055.107.07zm-.018.024l-.027.032c-.032-.014-.061-.033-.088-.055l.008-.045c.032.029.068.052.107.068z"
                transform="translate(1 6) translate(.96 1.493) translate(.067 1.195)"
              />
              <path
                fill="#C8B100"
                d="M2.591.536c0-.003-.002-.005-.004-.008l.091-.101.036.015.065-.072-.021-.031.114-.128h.005v.086l-.038.011v.095l.038.01V.5c-.017.006-.031.02-.037.036h-.068L2.76.501h-.1L2.65.536H2.59zm.15-.394v.1h-.1v-.1h.1zm.13.487c-.028 0-.05-.022-.05-.05 0-.027.022-.05.05-.05.028 0 .05.023.05.05 0 .028-.022.05-.05.05zM2.555.37l.037-.01V.262l-.037-.01V.212c.018-.006.032-.019.038-.036h.057l.011.036h.1l.012-.036h.066c.001.005.003.009.006.013L2.73.316 2.694.301 2.63.374l.021.03-.089.1L2.555.5V.369zm.14-.03l.042.034L2.68.44 2.637.404 2.695.34zm-.156.772c.026-.001.048-.02.053-.043.036-.005.07-.014.101-.028l-.018-.03c-.027.011-.056.02-.087.023-.006-.014-.018-.024-.033-.03v-.12l.037-.01V.778l-.038-.01V.605L2.56.603l.085.094-.022.03.066.073.035-.015.07.079c-.012.018-.011.042.003.06-.02.023-.043.043-.07.059l.019.03c.03-.018.057-.042.08-.068.02.006.04.002.056-.01.025-.02.028-.055.006-.078L2.884.853C2.9.82 2.91.784 2.913.747h-.037c-.003.032-.01.062-.023.091-.01-.001-.021 0-.031.003L2.75.763l.021-.031-.065-.073-.036.016L2.586.58l.005-.01h.059l.01.036h.101l.01-.035h.07c.006.016.02.028.036.034v.086h.037V.605c.023-.007.04-.028.04-.052 0-.025-.017-.046-.04-.053V.413l.037-.01V.308l-.038-.01V.21c.023-.007.04-.028.04-.052 0-.03-.026-.055-.059-.055-.026 0-.048.015-.055.038h-.066L2.762.106h-.1L2.65.142h-.057C2.586.12 2.564.104 2.54.104l-.002.178h.018v.056h-.018v.46h.017v.056h-.016v.257zM2.63.733l.042-.035.058.066-.042.034L2.63.733zm.184-.406h.1v.1h-.1v-.1zm-.171.31v-.1h.1v.1h-.1zm.208.14L2.939.77 2.95.674 2.864.662v.054c0 .021-.005.041-.013.061zM2.877.66l-.088.01s-.004.06-.002.047c.002-.016-.01.047-.01.047l.088.013c.01-.02.012-.04.012-.06V.66zm-.23.38L2.637.996c.032-.013.063-.031.089-.055l.027.029c-.032.03-.068.055-.108.07zm.018.024l.027.032c.032-.014.061-.033.088-.055L2.772.995c-.032.029-.068.052-.107.068z"
                transform="translate(1 6) translate(.96 1.493) translate(.067 1.195)"
              />
              <path
                fill="#058E6E"
                d="M2.482.553c0-.03.026-.055.058-.055.033 0 .059.025.059.055s-.026.055-.059.055c-.032 0-.058-.024-.058-.055"
                transform="translate(1 6) translate(.96 1.493) translate(.067 1.195)"
              />
            </g>
            <g fillRule="nonzero">
              <path
                fill="#AD1519"
                d="M0.003 1.2L1.073 1.2 1.073 0.011 0.003 0.011z"
                transform="translate(1 6) translate(.96 1.493) translate(1)"
              />
              <path
                fill="#C8B100"
                d="M.37.286H.35v-.02H.316v.08H.35V.4H.276v.157h.04v.316h-.08v.163h.607V.873H.764V.557h.04V.4H.73V.345h.034V.266H.73v.02H.71v-.02H.676v.02H.65v-.02H.616v.08h.035V.4H.577V.227h.04V.148h-.04v.02h-.02v-.02H.523v.02h-.02v-.02h-.04v.079h.04V.4H.429V.345h.035V.266H.429v.02h-.02v-.02H.37v.02zm-.133.789h.606m-.606-.04h.606M.237.995h.606M.237.957h.606M.237.912h.606M.316.878h.448M.316.838h.448M.316.794h.448M.316.754h.448M.316.715h.448M.316.675h.448M.316.636h.448M.276.596h.528M.276.558h.528M.276.517h.528M.276.479h.528M.35.438h.38M.503.4h.1M.503.36h.1m-.1-.04h.1m-.1-.039h.1m-.14-.05h.153M.35.4h.1M.316.35h.148m-.109.746v-.1m0 .021v-.1m-.04.04v.1m.075 0v-.1m.039.14v-.1m0 .02v-.1m0 .021v-.1m0 .016v-.1m-.04.219v-.1m-.073.1v-.1m.152 0v.1M.503.938v-.1M.39.798v.1m.078-.1v.1m.074-.1v.1M.502.855v-.1m.04-.039v.1m0-.179v.1m-.04-.14v.1m.04-.139v.1m-.074-.1v.1M.39.557v.1M.355.517v.1m.074-.1v.1m.074-.1v.1m.04-.139v.1m-.075-.1v.1M.39.478v.1M.355.44v.1m.148-.1v.1M.429.36v.1M.75.4h-.1M.764.35H.616m.188.746v-.1m0 .021v-.1m.04.04v.1m-.075 0v-.1m-.04.14v-.1m0 .02v-.1m0 .021v-.1m0 .016v-.1m.04.219v-.1m.074.1v-.1m-.153 0v.1M.656.938v-.1m.113-.04v.1M.69.799v.1m-.074-.1v.1m.04-.044v-.1M.616.715v.1m0-.179v.1m.04-.14v.1M.616.558v.1m.074-.1v.1m.08-.1v.1m.034-.14v.1M.73.518v.1m-.074-.1v.1M.616.479v.1m.074-.1v.1m.08-.1v.1M.803.44v.1m-.148-.1v.1M.73.36v.1M.577.854v-.1m0-.057v-.1m0 .179v-.1m0-.058v-.1m0 .021v-.1m0-.018v-.1m0 .02v-.1M.35.386h.1M.503.266h.1m.048.119h.1"
                transform="translate(1 6) translate(.96 1.493) translate(1)"
              />
              <path
                fill="#C8B100"
                d="M.641 1.036V.932c0-.02-.01-.08-.103-.08-.09 0-.099.06-.099.08v.104h.202z"
                transform="translate(1 6) translate(.96 1.493) translate(1)"
              />
              <path
                fill="#C8B100"
                d="M.5.973L.425.965c0-.03.008-.077.031-.092l.07.054C.515.934.5.957.5.973z"
                transform="translate(1 6) translate(.96 1.493) translate(1)"
              />
              <path
                fill="#C8B100"
                d="M.569.933l.03-.082C.585.842.562.833.544.833.534.833.51.843.498.851l.03.082h.04zM.615.973L.692.965c0-.03-.008-.077-.03-.092l-.07.054c.007.007.023.03.023.046zM.464.764V.656c0-.03-.02-.054-.055-.054-.034 0-.054.024-.054.054v.108h.109zM.616.764V.656c0-.03.02-.054.055-.054.034 0 .054.024.054.054v.108H.616zM.435.5L.44.4.34.4.351.5zM.583.5L.593.4.493.4.498.5zM.651.5L.641.4.741.4.731.5z"
                transform="translate(1 6) translate(.96 1.493) translate(1)"
              />
              <g fill="#0039F0">
                <path
                  d="M.244.438V.35C.244.335.234.29.174.29.122.29.112.335.112.35v.088h.133zM.102.157V.063C.102.04.086.014.052.014c-.033 0-.05.025-.05.05v.093h.1zM.264.157V.063C.264.04.28.014.314.014c.033 0 .05.025.05.05v.093h-.1z"
                  transform="translate(1 6) translate(.96 1.493) translate(1) translate(.363 .597)"
                />
              </g>
            </g>
            <g>
              <path
                fill="#CCC"
                fillRule="nonzero"
                d="M0.006 1.2L1.079 1.2 1.079 0.011 0.006 0.011 0.006 1.2z"
                transform="translate(1 6) translate(.96 1.493) translate(2.067)"
              />
              <path
                fill="#DB4446"
                fillRule="nonzero"
                d="M.553.329L.554.31l.002-.01S.522.305.504.298C.486.292.469.282.452.263.436.244.43.233.417.23.387.224.366.24.366.24s.021.01.038.037c.016.027.034.04.041.043.013.005.057.002.069.002l.04.006z"
                transform="translate(1 6) translate(.96 1.493) translate(2.067)"
              />
              <g>
                <path
                  fill="#ED72AA"
                  fillRule="nonzero"
                  d="M.543.107l.002.03C.546.15.54.163.543.17c.002.008.003.014.006.02.003.005.004.02.004.02L.538.199.525.19l.002.023c0 .006.005.019.01.026.007.007.02.02.023.029.004.01.003.03.003.03S.553.281.545.278C.536.275.518.265.518.265s.017.017.017.033S.528.332.528.332.52.318.51.308C.5.298.486.29.486.29s.011.025.011.042L.494.384S.486.37.477.364C.468.355.458.35.455.345.452.342.465.36.467.371c.001.011.007.05.04.1.02.03.052.08.118.064C.691.518.667.429.653.387.639.346.632.3.633.283c0-.016.012-.063.01-.072C.644.202.64.168.648.141.655.113.662.101.667.09.67.078.675.07.677.06L.678.032l.016.03c.003.009.003.033.003.033S.699.07.717.059C.738.047.758.035.764.03L.77.016S.768.058.757.074L.719.12S.735.113.745.113h.019S.75.123.734.148C.717.172.724.175.71.195.7.215.69.216.673.229.65.247.663.32.666.332.669.343.709.434.71.456c0 .022.004.07-.034.102C.65.578.61.578.6.585.591.59.573.609.573.647S.587.69.598.7c.01.01.025.004.028.012.003.007.004.011.01.016.004.004.007.01.005.017C.64.753.621.772.616.785.609.798.597.832.597.838c0 .005-.001.02.004.029 0 0 .02.022.006.027C.6.897.591.888.587.889.574.892.568.9.565.9.558.897.558.894.557.883c0-.011 0-.016-.004-.016S.546.871.545.877c0 .006 0 .019-.006.019C.534.896.526.886.522.884.517.882.504.88.503.874c0-.006.008-.018.016-.02C.528.85.535.847.53.843.525.838.52.838.514.843.509.847.497.843.498.837.498.83.5.822.499.819.5.815.49.808.501.8.514.794.52.807.531.805.545.803.55.798.556.79.559.784.559.768.55.759.542.749.533.748.53.742L.522.722s.003.026.001.03V.77L.506.753C.5.746.493.724.493.724v.029c0 .008.009.015.006.018C.495.774.48.756.477.753.473.75.46.74.455.73.45.72.445.705.445.7.442.695.44.672.442.666l.01-.024h-.03C.407.642.395.637.389.648.383.66.386.681.393.71c.008.028.013.042.01.047C.402.762.392.774.388.777.383.777.373.776.368.774.364.773.356.77.341.77h-.03C.307.767.294.76.288.761.28.764.27.77.273.778.278.79.27.794.263.793.255.793.25.79.242.788S.223.788.225.78C.227.77.23.77.234.763c.004-.007.005-.01 0-.011C.23.752.225.75.22.754.215.758.209.765.204.762.198.76.194.753.194.74.194.726.179.714.193.714c.013 0 .03.01.033.003C.229.71.227.707.22.7.212.695.204.691.213.684L.23.672C.233.67.238.656.244.66c.014.006 0 .015.014.03S.28.71.302.707C.324.704.331.702.331.695L.328.673.331.652S.321.658.318.665l-.01.017V.658L.31.64.305.62.299.64C.296.644.295.662.295.662S.281.65.285.63C.288.613.282.592.287.585.292.578.303.55.331.55h.06C.4.55.433.544.433.544S.371.51.357.5C.342.49.32.466.313.454.305.443.299.421.299.421S.287.42.277.427C.267.433.257.44.25.448.244.455.235.47.235.47L.237.444.235.426S.228.453.214.463C.199.473.182.488.182.488L.184.469.188.448S.178.463.162.466C.146.47.123.47.122.478c-.002.01.004.023 0 .03C.118.515.111.519.111.519S.1.512.094.511C.086.511.079.515.079.515S.072.506.074.5C.077.495.09.486.086.483.083.479.073.484.067.487S.048.493.05.483c0-.01.004-.016 0-.022C.049.454.05.449.056.448.059.446.079.448.08.444.082.439.076.434.063.43.05.428.044.42.05.414.058.407.059.406.062.4.065.394.067.384.078.39.09.393.087.406.1.41.111.416.14.41.145.407L.177.385.212.36.189.344C.183.338.173.324.167.32.162.32.135.308.127.308.116.308.09.298.09.298L.106.29C.111.287.12.278.125.279h.006S.105.278.1.276C.094.275.079.265.073.265L.055.267S.07.257.085.255C.096.252.107.253.107.253S.087.247.082.24L.07.22C.065.214.063.207.056.206.05.206.038.214.032.214.025.213.02.209.019.199.02.19.02.193.017.188.015.183.005.17.014.168.024.165.042.17.044.166.046.163.034.152.026.148.018.144.006.138.012.132.02.126.026.124.03.119.033.114.037.099.045.104.053.108.064.13.07.129.076.127.076.111.075.105.074.098.075.085.081.087c.006 0 .01.009.02.01.01 0 .025-.003.023.004 0 .007-.006.015-.013.023C.105.13.101.146.106.156.11.166.12.18.13.187.14.193.158.198.17.205.18.213.208.234.217.236l.018.007S.245.24.259.24.305.24.317.236C.329.23.345.222.34.21.335.201.308.191.31.182.314.174.324.173.34.172c.015 0 .038.003.042-.02C.386.13.387.116.365.112.342.105.325.105.32.088.316.073.312.07.317.064.322.06.33.057.347.056S.383.055.389.051C.394.047.395.036.402.03.408.027.434.023.434.023s.031.015.06.036c.026.02.05.048.05.048"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.17 .15)"
                />
                <path
                  d="M.235.243S.218.248.21.257C.203.27.204.28.204.28S.218.268.237.273C.256.278.257.28.266.28.273.28.293.272.293.272S.277.29.279.302c.002.013.004.02.003.025C.282.343.27.362.27.362S.276.358.292.354C.308.351.322.344.33.337.338.331.35.315.35.315s-.004.022 0 .03c.003.01.004.036.004.036S.363.372.372.368C.376.366.387.36.39.353.394.348.398.33.398.33S.4.35.406.36c.006.009.015.037.015.037S.427.378.434.37C.44.363.448.353.449.348L.447.329l.008.019M.212.41S.227.375.242.364C.257.353.277.332.282.33.289.328.313.31.313.31M.299.48S.34.452.354.44C.38.42.399.38.399.38M.59.266S.554.223.546.208C.538.195.524.166.524.166M.434.542s.103.027.1.05C.53.613.477.641.477.641"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.17 .15)"
                />
              </g>
              <path
                fill="#000"
                fillRule="nonzero"
                d="M.523.315S.506.267.503.253C.5.24.49.223.49.223s.088 0 .085.028C.574.278.548.278.542.288c-.005.01-.02.027-.02.027zM.579.233L.576.201s.038 0 .055.02C.66.25.677.298.676.3.671.307.65.28.634.272c0 0-.011.004-.022.004S.596.267.594.26C.593.25.596.237.596.237L.579.233z"
                transform="translate(1 6) translate(.96 1.493) translate(2.067)"
              />
              <g fill="#000" fillRule="nonzero">
                <path
                  d="M0.036 0.148L0.069 0.096 0.103 0.144 0.036 0.148"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.47 .235)"
                />
                <path
                  d="M.047.148L.087.095.13.143.047.148M.04.031L.122.06.048.098.04.031"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.47 .235)"
                />
                <path
                  d="M0.064 0.038L0.137 0.056 0.078 0.102 0.064 0.038"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.47 .235)"
                />
              </g>
              <g fill="#DB4446" fillRule="nonzero">
                <path
                  d="M.125.084S.152.1.173.101c.02.002.042.002.045.002.003 0 .01-.022.007-.038C.213.015.152.003.152.003s.019.03.01.045C.149.068.125.084.125.084zM.116.09S.101.047.07.053C.037.059.016.097.016.097S.052.096.06.105c.013.013.017.047.017.047s.02-.018.025-.03C.108.111.116.09.116.09z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.128 .192)"
                />
                <path
                  d="M.093.133S.057.14.037.163C.017.188.02.233.02.233S.044.206.065.206C.087.206.12.214.12.214S.11.186.11.174.093.134.093.134zM.157.367S.14.334.108.344c-.03.01-.05.07-.05.07S.083.403.098.41c.015.006.026.033.026.033S.14.42.145.409L.156.367z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.128 .192)"
                />
                <path
                  d="M.143.413S.111.407.083.433c-.028.028-.03.08-.03.08S.08.484.101.488c.02.003.045.017.045.017l.006-.04C.157.442.143.413.143.413z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.128 .192)"
                />
                <path
                  d="M.12.473s-.002.04.023.066c.026.027.074.03.074.03S.2.543.198.53C.194.507.221.488.221.488S.196.47.173.47C.148.47.12.474.12.474zM.32.647S.302.607.276.608C.248.61.221.652.221.652S.254.647.262.666C.271.685.28.708.28.708S.294.695.301.686C.307.678.32.647.32.647z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.128 .192)"
                />
                <path
                  d="M.277.682S.233.674.212.702C.191.73.192.781.192.781S.218.745.242.748c.024.003.05.019.05.019L.285.722.277.682z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.128 .192)"
                />
                <path
                  d="M.283.745S.256.778.276.805c.02.027.062.04.062.04S.322.825.329.802C.335.785.37.76.37.76L.283.745zM.587.773S.55.761.53.778C.51.795.494.87.494.87S.527.829.55.834c.023.005.041.02.041.02s.004-.03 0-.051C.593.79.588.773.588.773z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.128 .192)"
                />
                <path
                  d="M.56.834S.53.862.54.886C.552.91.572.934.572.934S.57.9.584.89C.603.875.637.873.637.873S.61.853.601.85C.592.847.561.834.561.834z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.128 .192)"
                />
                <path
                  d="M.616.862s-.018.036.017.06c.035.023.066.025.066.025S.67.91.679.891C.69.87.713.858.713.858S.668.846.662.848C.654.847.615.861.615.861z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.128 .192)"
                />
              </g>
              <g fillRule="nonzero">
                <path
                  fill="#C8B100"
                  d="M.125.08H.12L.114.087C.108.092.1.093.095.089.093.086.092.083.092.079.09.083.085.083.082.08.075.077.074.07.078.064.079.06.079.06.08.059V.052L.072.054.071.058C.066.063.059.064.056.06.054.06.053.056.053.056L.05.058C.038.061.033.036.033.029L.03.035s.004.014.002.027L.025.088c.016.004.04.017.063.035.024.018.043.038.05.052 0 0 .013-.007.025-.011C.176.16.193.159.193.159L.196.155C.19.155.163.157.164.145L.166.143.159.14C.155.138.155.13.16.126L.164.123V.116H.157C.156.119.154.12.153.12.147.125.14.125.135.12.132.118.13.114.132.11h-.01C.118.105.117.097.122.091.122.09.127.086.127.086L.126.079z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <g fill="#000">
                  <path
                    d="M.084.082C.09.075.1.076.107.082s.01.016.006.021C.108.11.098.11.09.103.082.096.08.086.084.082z"
                    transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085) translate(.021 .043)"
                  />
                  <path
                    d="M.11.113L.077.088C.071.084.07.076.073.072c.004-.004.012-.004.018 0l.033.026.033.025C.162.127.165.135.161.14S.15.143.143.14L.11.113"
                    transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085) translate(.021 .043)"
                  />
                  <path
                    d="M.075.09L.049.073C.042.07.039.062.042.057.045.052.052.051.059.055l.026.016.026.015C.117.09.12.097.118.102.115.107.107.108.1.104L.075.09"
                    transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085) translate(.021 .043)"
                  />
                  <path
                    d="M.045.059C.05.053.06.053.069.059c.008.007.01.016.005.022C.069.086.059.086.05.08S.04.065.045.059zM.15.131C.153.126.151.117.143.111.136.103.125.103.12.11.116.114.118.124.126.13s.018.006.023 0z"
                    transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085) translate(.021 .043)"
                  />
                  <path
                    d="M.143.142l.022.021C.17.168.178.17.183.166.187.162.187.156.183.15L.16.13.14.107C.134.103.125.101.121.105.116.108.117.116.122.121l.021.021"
                    transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085) translate(.021 .043)"
                  />
                  <path
                    d="M.182.163C.187.157.185.148.177.143.169.134.159.134.154.14.149.147.15.156.159.163c.008.005.018.006.023 0z"
                    transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085) translate(.021 .043)"
                  />
                </g>
                <path
                  fill="#C8B100"
                  d="M0.15 0.029L0.091 0.03 0.08 0.115 0.086 0.129 0.101 0.128 0.177 0.078 0.15 0.029"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M0.15 0.029L0.091 0.03 0.08 0.115 0.086 0.129 0.101 0.128 0.177 0.078 0.15 0.029"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M0.061 0.063L0.059 0.117 0.145 0.129 0.159 0.122 0.157 0.107 0.108 0.036 0.061 0.063"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M0.175 0.117L0.129 0.144 0.079 0.073 0.078 0.058 0.091 0.052 0.178 0.063 0.175 0.117"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M.095.076C.103.063.12.06.134.067c.014.007.018.024.01.037-.008.013-.026.017-.04.01C.092.104.088.088.095.075z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M.078.103C.076.103.066.065.053.045.045.029.015.009.015.009.018.005.055-.006.1.017.136.042.097.088.097.088S.087.099.078.103z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M0.128 0.081L0.089 0.118 0.028 0.058 0.033 0.05 0.036 0.035 0.119 0.028 0.128 0.081"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M.051.062C.056.047.07.039.08.042.09.046.094.06.09.075.084.09.071.098.06.095.05.09.045.077.051.062zM.206.064L.149.058.124.143.129.157.144.158.224.117.206.064"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M0.114 0.082L0.105 0.136 0.19 0.159 0.204 0.155 0.205 0.141 0.164 0.062 0.114 0.082"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M0.214 0.154L0.163 0.174 0.123 0.096 0.124 0.081 0.139 0.078 0.223 0.101 0.214 0.154"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M.142.101C.152.09.17.088.182.097c.013.01.015.026.005.038C.177.147.16.148.147.14.133.13.131.113.141.101z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M0.254 0.11L0.264 0.165 0.181 0.195 0.165 0.191 0.164 0.177 0.199 0.096 0.254 0.11"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M0.246 0.201L0.192 0.214 0.163 0.131 0.166 0.116 0.181 0.114 0.263 0.149 0.246 0.201"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M0.162 0.11L0.145 0.162 0.227 0.196 0.242 0.194 0.245 0.18 0.216 0.097 0.162 0.11"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M.223.175C.235.165.235.147.225.136.215.126.196.126.185.134.172.145.171.162.182.174c.01.01.03.011.04.001z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M.198.204s.037.003.059.009C.27.217.295.24.295.24.299.236.304.198.275.16.244.134.208.184.208.184S.2.195.2.203z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M0.21 0.142L0.181 0.188 0.257 0.239 0.266 0.231 0.279 0.227 0.267 0.139 0.21 0.142"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
                <path
                  fill="#C8B100"
                  d="M.247.213C.261.206.268.191.262.182.256.173.24.172.226.18.212.188.206.202.212.211c.005.009.021.01.035.002z"
                  transform="translate(1 6) translate(.96 1.493) translate(2.067) translate(.576 .085)"
                />
              </g>
            </g>
            <g
              fillRule="nonzero"
              transform="translate(1 6) translate(.96 1.493) translate(1.725 .79)"
            >
              <circle cx=".351" cy=".406" r="1" fill="#AD1519" />
              <circle cx=".351" cy=".405" r="1" fill="#005BBF" />
              <g fill="#C8B100">
                <path
                  d="M.086.016S.057.047.057.076c0 .03.012.055.012.055C.065.119.053.111.04.111.022.11.007.124.007.14c0 .005.003.013.005.017l.01.02C.027.172.035.168.045.168c.012 0 .023.01.023.021L.066.193H.04v.023h.023L.046.25.069.241l.017.02.018-.02.023.009L.11.216h.023V.194H.107V.187c0-.012.01-.021.022-.021.01 0 .017.004.02.012L.16.158C.162.154.165.146.165.14c0-.017-.014-.03-.031-.03-.015 0-.026.008-.03.02 0 0 .012-.025.012-.054 0-.03-.03-.061-.03-.061z"
                  transform="translate(.15 .192)"
                />
                <path
                  d="M0.04 0.294L0.14 0.294 0.14 0.194 0.04 0.194z"
                  transform="translate(.15 .192)"
                />
              </g>
              <g fill="#C8B100">
                <path
                  d="M.086.016S.057.047.057.076c0 .03.012.055.012.055C.065.119.053.111.04.111.022.11.007.124.007.14c0 .005.003.013.005.017l.01.02C.027.172.035.168.045.168c.012 0 .023.01.023.021L.066.193H.04v.023h.023L.046.25.069.241l.017.02.018-.02.023.009L.11.216h.023V.194H.107V.187c0-.012.01-.021.022-.021.01 0 .017.004.02.012L.16.158C.162.154.165.146.165.14c0-.017-.014-.03-.031-.03-.015 0-.026.008-.03.02 0 0 .012-.025.012-.054 0-.03-.03-.061-.03-.061z"
                  transform="translate(.376 .192)"
                />
                <path
                  d="M0.04 0.294L0.14 0.294 0.14 0.194 0.04 0.194z"
                  transform="translate(.376 .192)"
                />
              </g>
              <g fill="#C8B100">
                <path
                  d="M.086.016S.057.047.057.076c0 .03.012.055.012.055C.065.119.053.111.04.111.022.11.007.124.007.14c0 .005.003.013.005.017l.01.02C.027.172.035.168.045.168c.012 0 .023.01.023.021L.066.193H.04v.023h.023L.046.25.069.241l.017.02.018-.02.023.009L.11.216h.023V.194H.107V.187c0-.012.01-.021.022-.021.01 0 .017.004.02.012L.16.158C.162.154.165.146.165.14c0-.017-.014-.03-.031-.03-.015 0-.026.008-.03.02 0 0 .012-.025.012-.054 0-.03-.03-.061-.03-.061z"
                  transform="translate(.263 .387)"
                />
                <path
                  d="M0.04 0.294L0.14 0.294 0.14 0.194 0.04 0.194z"
                  transform="translate(.263 .387)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export { FlagEs };
